// extracted by mini-css-extract-plugin
module.exports = {"leftSideInfo":"LayoutLeft_leftSideInfo__375L2"};